'use client';

import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type FaIconProps = {
  icon: IconDefinition;
  className?: string;
} & Omit<FontAwesomeIconProps, 'icon'>;

export function FaIcon({ icon, className, ...rest }: FaIconProps) {
  return <FontAwesomeIcon icon={icon} className={className} {...rest} />;
}
